import { render, staticRenderFns } from "./vouchers.vue?vue&type=template&id=6fbf82ca&scoped=true&"
import script from "./vouchers.vue?vue&type=script&lang=js&"
export * from "./vouchers.vue?vue&type=script&lang=js&"
import style0 from "./vouchers.vue?vue&type=style&index=0&id=6fbf82ca&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fbf82ca",
  null
  
)

export default component.exports